export default __webpack_public_path__ + "static/media/codIcon.50b08bd3.png";